"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.marketingPrefs = exports.titleCaseMarketingPrefs = exports.makeTitleCase = exports.ProfileEditMarketingUI = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var screen_reader_route_manager_1 = __importDefault(require("screen-reader-route-manager"));
var __generated__1 = require("../../../../../shared/api/kapi/v1/__generated__/");
var core_1 = require("../../../../../shared/core");
var components_1 = require("../../../../../shared/core/components");
var analytics_subjects_1 = require("../../../analytics-subjects");
var components_2 = require("../../../components");
var copy_1 = require("../../../copy");
var section_ids_1 = require("../../../section-ids");
var ProfileEditMarketingUI = function (_a) {
    var _b;
    var profile = _a.profile, mutate = _a.mutate, mutationLoading = _a.mutationLoading;
    var profileLink = (0, core_1.useLinks)().profile;
    var navigate = (0, ui_tools_1.useNavigate)();
    var routeProfileHandler = function () {
        navigate(profileLink());
    };
    return (react_1.default.createElement(ui_tools_1.AnalyticsRender, { name: analytics_subjects_1.PROFILE_EDIT_MARKETING_PREFERENCES, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(ProfileEditMarketingFormMain, { marketingPreferences: profile.marketingPreferences, onRouteProfile: routeProfileHandler, mutate: mutate, mutationLoading: mutationLoading })));
};
exports.ProfileEditMarketingUI = ProfileEditMarketingUI;
var makeTitleCase = function (string) {
    return string[0].toUpperCase() + string.slice(1).toLowerCase();
};
exports.makeTitleCase = makeTitleCase;
var titleCaseMarketingPrefs = function (pref) {
    return pref === 'SMS' ? pref : (0, exports.makeTitleCase)(pref);
};
exports.titleCaseMarketingPrefs = titleCaseMarketingPrefs;
exports.marketingPrefs = [
    __generated__1.CommunicationChannel.Email,
    __generated__1.CommunicationChannel.Phone,
    __generated__1.CommunicationChannel.Post,
    __generated__1.CommunicationChannel.Sms,
];
function ProfileEditMarketingFormMain(_a) {
    var _b, _c;
    var existingMarketingPreferences = _a.marketingPreferences, onRouteProfile = _a.onRouteProfile, mutate = _a.mutate, mutationLoading = _a.mutationLoading;
    var _d = __read((0, react_1.useState)(false), 2), apiError = _d[0], setApiError = _d[1];
    var _e = (0, core_1.useComponents)(), PrimaryCTAButton = _e.PrimaryCTAButton, Checkbox = _e.Checkbox, CheckboxField = _e.CheckboxField, Heading1 = _e.Heading1, Card = _e.Card, Stack = _e.Stack, Margin = _e.Margin, ErrorNotification = _e.ErrorNotification, ButtonGroup = _e.ButtonGroup;
    var _f = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _f.copy, Copy = _f.Copy;
    var profile = (0, core_1.useLinks)().profile;
    var _g = __read((0, react_1.useState)(existingMarketingPreferences || []), 2), marketingPreferences = _g[0], setMarketingPreferences = _g[1];
    var handleSubmit = function (event) {
        event.preventDefault();
        if (mutationLoading) {
            return;
        }
        setApiError(false);
        var body = getSubmitBody({ marketingPreferences: existingMarketingPreferences || [] }, { marketingPreferences: marketingPreferences });
        if (Object.keys(body).length === 0) {
            screen_reader_route_manager_1.default.beforeRouteChange();
            onRouteProfile();
            return;
        }
        mutate(body, {
            onError: function () {
                setApiError(true);
            },
            onCompleted: function () {
                screen_reader_route_manager_1.default.beforeRouteChange();
                onRouteProfile();
            },
        });
    };
    var handleMarketingPreferenceChange = function (_a) {
        var _b = _a.currentTarget, value = _b.value, checked = _b.checked;
        var allMarketingPreferences = checked
            ? __spreadArray(__spreadArray([], __read(marketingPreferences), false), [value], false) : marketingPreferences.filter(function (pref) { return pref !== value; });
        setMarketingPreferences(allMarketingPreferences);
    };
    return (react_1.default.createElement(Card, { "data-testid": section_ids_1.PROFILE_EDIT_MARKETING_SECTION_ID },
        react_1.default.createElement(Stack, { spaceBetween: [2, 4] },
            apiError ? (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.PROFILE_UPDATE_ERROR_NOTIFICATION, properties: (_b = {},
                    _b[core_1.INTERNAL_EVENT_FLAG] = true,
                    _b) },
                react_1.default.createElement(ErrorNotification, { id: section_ids_1.PROFILE_UPDATE_ERROR, "data-testid": section_ids_1.PROFILE_UPDATE_ERROR },
                    react_1.default.createElement(Copy, { copyKey: "profile.updateError" })))) : null,
            react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.PROFILE_MARKETING_PREFERENCES_CANCEL, properties: { INTERNAL_EVENT_FLAG: true } },
                react_1.default.createElement(components_1.Breadcrumb, { "data-testid": "breadcrumb", href: profile() }, copy('profile.backtoProfile'))),
            react_1.default.createElement("div", null,
                react_1.default.createElement(Heading1, null, copy('profile.editMarketingPreferencesHeading'))),
            react_1.default.createElement("form", { onSubmit: handleSubmit, noValidate: true },
                react_1.default.createElement(Copy, { copyKey: "profile.editMarketingPreferencesIntro" }),
                mutationLoading ? (react_1.default.createElement(Copy, { copyKey: "profile.editMarketingPreferencesLoadingText" })) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(CheckboxField, { label: copy('profile.editMarketingPreferencesOptionsGroupLabel') }, exports.marketingPrefs.map(function (pref) { return (react_1.default.createElement(Checkbox, { "data-testid": "marketing-check-box-".concat(pref), key: pref, id: pref, checked: marketingPreferences &&
                            marketingPreferences.includes(pref), value: pref, onChange: handleMarketingPreferenceChange, label: (0, exports.titleCaseMarketingPrefs)(pref) })); })),
                    react_1.default.createElement(Margin, { top: 8 },
                        react_1.default.createElement(ButtonGroup, null,
                            react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.PROFILE_MARKETING_PREFERENCES_SAVE, properties: (_c = {}, _c[core_1.INTERNAL_EVENT_FLAG] = true, _c) },
                                react_1.default.createElement(PrimaryCTAButton, { "data-testid": "update-profile", type: "submit", disabled: mutationLoading }, copy('profile.save')))))))),
            react_1.default.createElement(Margin, { top: 4 },
                react_1.default.createElement(components_2.TermsAndConditions, null)))));
}
function getSubmitBody(_a, _b) {
    var oldMarketingPreferences = _a.marketingPreferences;
    var newMarketingPreferences = _b.marketingPreferences;
    var body = {};
    if (JSON.stringify(sortMarketingPrefs(oldMarketingPreferences)) !==
        JSON.stringify(sortMarketingPrefs(newMarketingPreferences))) {
        body.marketingPreferences = newMarketingPreferences;
    }
    return body;
}
function sortMarketingPrefs(marketingPrefs) {
    var sortedPrefs = __spreadArray([], __read(marketingPrefs), false);
    sortedPrefs.sort();
    return sortedPrefs;
}
